export enum ApprovalStatus {
    pending = "pending",
    approved = "approved",
    rejected = "rejected"
}
